import { Role } from "@/interfaces/AccessControl";
import { CommonRoute } from "./routes";
import { getEnvironmentVariable } from "@/utils/environment";

export const EMPTY_ID_ROLE = 0;

export const Rol = {
  CITAS_MEDICAS: 1,
  EVALUATOR: 2,
  EJECUTIVO_DESGRAVAMEN: 3,
  EJECUTIVO_BANCO: 4,
  TASADOR: 5,
  CONSEJERO: 6,
} as const;

export const PAGE_BY_ROLE = {
  [EMPTY_ID_ROLE]: CommonRoute.ROLES,
  [Rol.CITAS_MEDICAS]: CommonRoute.REQUESTS,
  [Rol.EJECUTIVO_DESGRAVAMEN]: CommonRoute.REQUIREMENTS,
  [Rol.EVALUATOR]: CommonRoute.EVALUATIONS,
}

export const ROLES_DETAIL = [
  {
    segcenObject: import.meta.env.VITE_APP_SEGCEM_ROL_EXECUTIVE_BANK,
    description: "Registro y Seguimiento de Solicitudes",
    segcenAction: "001",
    id: Rol.EJECUTIVO_BANCO,
  },
  {
    segcenObject: import.meta.env.VITE_APP_SEGCEM_ROL_APPOINMENT_MEDICAL,
    description: "Gestión de Citas Médicas",
    segcenAction: "001",
    id: Rol.CITAS_MEDICAS,
  },
  {
    segcenObject: import.meta.env.VITE_APP_SEGCEM_ROL_EXECUTIVE_DESGRAVAMEN,
    description: "Gestión de Requisitos",
    segcenAction: "001",
    id: Rol.EJECUTIVO_DESGRAVAMEN,
  },
  {
    segcenObject: import.meta.env.VITE_APP_SEGCEM_ROL_EVALUATOR,
    description: "Evaluación de Solicitud",
    segcenAction: "001",
    id: Rol.EVALUATOR,
  },
  {
    segcenObject: import.meta.env.VITE_APP_SEGCEM_ROL_APPRAISER,
    description: "Seguro de Inmueble",
    segcenAction: "001",
    id: Rol.TASADOR,
  },
  {
    segcenObject: import.meta.env.VITE_APP_SEGCEM_ROL_COUNSELOR,
    description: "Evaluador de Inmueble",
    segcenAction: "001",
    id: Rol.CONSEJERO,
  },
] satisfies Role[];

export const APPLICATION_ROLE = {
  MEDICAL_APPOINTMENT: '1',
  EVALUATOR: '2',
  EXECUTIVE_DESGRAVAMEN: '3',
  BANK_EXECUTIVE: '4',
} as const;

export const REQUEST_STATUS = {
  IN_PROGRESS: 1,
  APPROVED: 2,
  CANCELED: 3,
  PENDING_REQUIREMENT: 4,
  REQUIREMENT_COMPLETED: 5,
  APPROVED_WITH_OBSERVATION: 6,
  REJECTED: 7,
  PENDING_SIGNATURE: 8,
  NEW_REQUIREMENT_COMPLETED: 9,
  REVIEWED: 10,
} as const;

export const ROLES_AND_STATES_ALLOWED_TO_CANCEL_REQUEST = {
  BANK_EXECUTIVE: [
    REQUEST_STATUS.IN_PROGRESS,
    REQUEST_STATUS.PENDING_SIGNATURE,
  ] as number[],
  LOAN_EXECUTIVE: [
    REQUEST_STATUS.IN_PROGRESS,
    REQUEST_STATUS.PENDING_SIGNATURE,
    REQUEST_STATUS.NEW_REQUIREMENT_COMPLETED,
    REQUEST_STATUS.PENDING_REQUIREMENT,
    REQUEST_STATUS.REQUIREMENT_COMPLETED,
    REQUEST_STATUS.REVIEWED,
  ] as number[],
  MEDICAL_APPOINTMENT_EXECUTIVE: [
    REQUEST_STATUS.IN_PROGRESS,
    REQUEST_STATUS.PENDING_SIGNATURE,
    REQUEST_STATUS.NEW_REQUIREMENT_COMPLETED,
    REQUEST_STATUS.PENDING_REQUIREMENT,
    REQUEST_STATUS.REQUIREMENT_COMPLETED,
    REQUEST_STATUS.REVIEWED,
  ] as number[],
  SENIOR_SUBSCRIBER: [
    REQUEST_STATUS.IN_PROGRESS,
    REQUEST_STATUS.PENDING_SIGNATURE,
    REQUEST_STATUS.NEW_REQUIREMENT_COMPLETED,
    REQUEST_STATUS.PENDING_REQUIREMENT,
    REQUEST_STATUS.REQUIREMENT_COMPLETED,
    REQUEST_STATUS.REVIEWED,
  ] as number[],
};

export const API_ROLE_VERSION = {
  [Rol.CITAS_MEDICAS]: getEnvironmentVariable("VITE_APP_URL_MEDICAL_APPOINMENT_MANAGEMENT"),
  [Rol.EJECUTIVO_DESGRAVAMEN]: getEnvironmentVariable("VITE_APP_API_REQUIREMENTS_INSURED"),
  [Rol.EVALUATOR]: getEnvironmentVariable("VITE_API_URL_PREFIX_EVALUATION")
}